import contentDisposition from 'content-disposition';
import fileDownload from 'js-file-download';
import { http } from 'utils';

export const httpFile = async (params) => {
  const { headers, data: exportFile } = await http({...params, onlyData: false});
  const { parameters } = contentDisposition.parse(headers['content-disposition']);
  fileDownload(exportFile, parameters.filename);
};
